// AppFooter.tsx
import type { loader } from "./../../root";
import {
  Link,
  useRouteLoaderData,
} from "@remix-run/react";
import clsx from "clsx";
import React from "react";
import Logo from "~/assets/ourpr_logo.svg";
import FlowRow from "./FlowRow";

interface AppFooterProps {}

const menuData = [
  {
    text: "OURPRについて",
    link: "/about",
  },
  {
    text: "公式Xアカウント",
    link: "https://x.com/ourpr_jp",
    isExternal: true,
  },
  {
    text: "特定商取引法",
    link: "https://item-item.notion.site/112dcec67b158054a019f2899ef394c5",
    isExternal: true,
  },
  {
    text: "お問い合わせ",
    link: "http://item-item.notion.site",
    isExternal: true,
  },
  {
    text: "運営会社 株式会社DE",
    link: "https://deinc.jp",
    isExternal: true,
  },
];

const AppFooter: React.FC<
  AppFooterProps
> = () => {
  const root =
    useRouteLoaderData<typeof loader>("root");

  return (
    <div
      className={clsx("pt-120", "max-md:pt-90")}
    >
      <div
        className={clsx(
          "border-t",
          "border-black",
          "border-b",
          "py-20",
        )}
      >
        <FlowRow>
          <div className={clsx("pr-50")}>
            <img
              className={clsx(
                "w-[6vw]",
                "max-md:w-100",
              )}
              src={Logo}
              alt=""
            />
          </div>
        </FlowRow>
      </div>
      <div
        className={clsx(
          "grid",
          "grid-rows-[1fr_auto]",
          "grid-cols-[1fr_auto]",
          "px-60",
          "pb-48",
          "pt-40",
          "max-md:flex",
          "max-md:flex-col",
          "max-md:px-20",
        )}
      >
        <div
          className={clsx(
            "col-[1 / 2]",
            "row-[1 / 2]",
            "w-174",
          )}
        >
          <Link to="/">
            <img src={Logo} alt="" />
          </Link>
        </div>
        <div
          className={clsx(
            "col-[2/3]",
            "row-[1/3]",
            "max-md:mt-30",
          )}
        >
          {!root?.subscription_active && (
            <div
              className={clsx(
                "font-semibold",
                "max-md:text-18",
              )}
            >
              <Link to="/select-plan">
                配信したい方はこちら
              </Link>
            </div>
          )}
          <ul
            className={clsx(
              "flex",
              "flex-col",
              "text-gray-500",
              "text-right",
              "text-sm",
              "gap-7",
              "mt-16",
              "max-md:text-left",
              "max-md:gap-12",
              "max-md:text-14",
            )}
          >
            {menuData.map((el, i) => {
              return (
                <li key={i}>
                  {el.isExternal ? (
                    <a
                      href={el.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {el.text}
                    </a>
                  ) : (
                    <Link to={el.link}>
                      {el.text}
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
        <div
          className={clsx(
            "col-[1/2]",
            "row-[2/3]",
            "text-xs",
            "text-gray-500",
            "max-md:text-14",
            "max-md:mt-40",
          )}
        >
          2025 © 株式会社DE
        </div>
      </div>
    </div>
  );
};

export default AppFooter;
